
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import PageObserver from "../Translation/PageObserver";
import FreeTierBanner from "../Plan/FreeTierBanner";
import JourneyReturnBar from "../onboarding/JourneyReturnBar";
import SupportApprovalBanner from "../Support/SupportApprovalBanner";
import GuidanceInbox from "../Support/GuidanceInbox";
import ImpersonationBanner from "../Support/ImpersonationBanner";

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen flex-col hero-dark-gradient">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:inline-flex focus:min-h-11 focus:items-center focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        Hoppa till innehåll
      </a>
      <Header />
      <main id="main" className="flex-1">
        <JourneyReturnBar />
        <div className="container mx-auto px-4">
          <FreeTierBanner />
          <ImpersonationBanner />
          <SupportApprovalBanner />
          <GuidanceInbox />
        </div>
        {children}
      </main>
      <footer className="border-t border-white/10 px-4 py-6 text-xs text-on-hero/60">
        <div className="container mx-auto flex flex-wrap items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} Byggarbetsmiljökontrollen</span>
          <nav className="flex flex-wrap gap-4">
            <Link to="/villkor" className="hover:text-on-hero">
              Användarvillkor
            </Link>
            <Link to="/integritetspolicy" className="hover:text-on-hero">
              Integritetspolicy
            </Link>
            <Link to="/verifiera" className="hover:text-on-hero">
              Verifiera dokument
            </Link>
          </nav>
        </div>
      </footer>
      {/* PageObserver is now used inside MainLayout which is always within Router */}
      <PageObserver />
    </div>
  );
};

export default MainLayout;
